import React from "react";
import Modal from "react-bootstrap/Modal";
import Select from "react-select";
import InputText from "../../common/Input/InputText";

const PhysicianAssociation = ({
  physician,
  associateFormData,
  handleDataChange,
  handleAssociatePhysician,
  handleCloseAssociateModal,
  associateModalVisible,
  handlePhysicianChange,
}) => {
  return (
    <>
      <Modal
        show={associateModalVisible}
        onHide={() => {
          handleCloseAssociateModal();
        }}
        size={"lg"}
      >
        <Modal.Header
          closeButton
          onClick={() => {
            handleCloseAssociateModal();
          }}
        >
          <Modal.Title>ASSOCIATE PHYSICIAN</Modal.Title>{" "}
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={handleAssociatePhysician}>
            <div className="row">
              <div className="col-xl-6">
                <div className="form-group">
                  <label className="col-form-label">Physician</label>
                  <Select
                    name="physician"
                    value={
                      associateFormData?.physicianId
                        ? {
                            value: associateFormData?.physicianId,
                            label: associateFormData?.physicianName,
                          }
                        : null
                    }
                    placeholder="Please select Physician"
                    onChange={(data) => handlePhysicianChange(data)}
                    options={
                      physician &&
                      physician?.map((item) => ({
                        value: item?._id,
                        label: item?.userId?.name,
                      }))
                    }
                  />
                </div>
              </div>
              <div className="col-xl-6">
                <div className="form-group">
                  <InputText
                    name="regularFees"
                    value={associateFormData?.regularFees}
                    onChange={handleDataChange}
                    label="Consultation Fee (Regular)"
                    placeholder="Consultation Fee (regular)"
                    required
                  />
                </div>
              </div>
              <div className="col-xl-6">
                <div className="form-group">
                   <InputText
                    name="followupFees"
                    value={associateFormData?.followupFees}
                    onChange={handleDataChange}
                    label="Consultation Fee (Follw-Up)"
                    placeholder="Consultation Fee (Follw-Up)"
                    required
                  />
                </div>
              </div>
              <div className="col-xl-6">
                <div className="form-group">
                  <InputText
                    name="emergencyFees"
                    value={associateFormData?.emergencyFees}
                    onChange={handleDataChange}
                    label="Consultation Fee (Emergency)"
                    placeholder="Consultation Fee (Emergency)"
                    required
                  />
                </div>
              </div>
              <div className="col-xl-6">
                <div className="form-group">
                  <InputText
                    name="videConsultationFees"
                    value={associateFormData?.videConsultationFees}
                    onChange={handleDataChange}
                    label="Consultation Fee (Video)"
                    placeholder="Consultation Fee (Video)"
                    required
                  />
                </div>
              </div>
              <div className="col-xl-6">
                <div className="form-group">
                  <InputText
                    name="establishmentFees"
                    value={associateFormData?.establishmentFees}
                    onChange={handleDataChange}
                    label="Establishment Fee"
                    placeholder="Establishment Fee"
                    required
                  />
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button type="submit" className="btn btn-primary">
                Associate
              </button>
              <button
                type="button"
                className="btn btn-secondary"
                onClick={() => {
                  handleCloseAssociateModal();
                }}
              >
                Cancel
              </button>
            </div>
          </form>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default PhysicianAssociation;
